import { useState } from "react";

import { useGetUserProfileAPI } from "@/api/userProfile/useUserProfileAPI";
import {
  addRecentChatSearch,
  readRecentChatSearches,
  writeRecentChatSearches
} from "@/utils/recentChatSearches";

/**
 * Returns the recent chat searches of the signed-in user, and saves `query`
 * (the search the user settled on) at the top of that list.
 */
export const useRecentChatSearches = (query: string) => {
  const { data: userProfile } = useGetUserProfileAPI();
  const email = userProfile?.email_address;

  const [stored, setStored] = useState(() => ({
    email,
    terms: readRecentChatSearches(email)
  }));
  const [lastSavedQuery, setLastSavedQuery] = useState("");

  if (stored.email !== email) {
    setStored({ email, terms: readRecentChatSearches(email) });
  } else if (email && query !== "" && query !== lastSavedQuery) {

    const terms = addRecentChatSearch(stored.terms, query);
    
    setLastSavedQuery(query);
    setStored({ email, terms });
    writeRecentChatSearches(email, terms);
  }

  return stored.terms;
};
